"use client";
function i(t) {
  const n = /^#?([0-9a-fA-F]{6})$/.exec(t.trim());
  if (!n) return null;
  const e = parseInt(n[1], 16), c = e >> 16 & 255, o = e >> 8 & 255, s = e & 255, r = (u) => {
    const f = u / 255;
    return f <= 0.03928 ? f / 12.92 : Math.pow((f + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * r(c) + 0.7152 * r(o) + 0.0722 * r(s);
}
function a(t) {
  const n = i(t);
  return n === null ? "#ffffff" : n > 0.5 ? "#000000" : "#ffffff";
}
export {
  a as getContrastTextColor
};
//# sourceMappingURL=index16.js.map
